import { render, staticRenderFns } from "./VirtualDropdown.vue?vue&type=template&id=cfde9358&scoped=true"
import script from "./VirtualDropdown.vue?vue&type=script&lang=js"
export * from "./VirtualDropdown.vue?vue&type=script&lang=js"
import style0 from "./VirtualDropdown.vue?vue&type=style&index=0&id=cfde9358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfde9358",
  null
  
)

export default component.exports